import {
  FETCH_GATING_REQUEST, FETCHING_GATING_SUCCEEDED, FETCHING_GATING_FAILED,
  FETCH_GATINGS_REQUEST, FETCHING_GATINGS_SUCCEEDED, FETCHING_GATINGS_FAILED,
  FETCH_PUBLISHED_GATINGS_REQUEST, FETCH_PUBLISHED_GATINGS_SUCCEEDED, FETCH_PUBLISHED_GATINGS_FAILED,
  CREATE_GATING_REQUEST, CREATING_GATING_SUCCEEDED, CREATING_GATING_FAILED,
  UPDATE_GATING_REQUEST, UPDATING_GATING_SUCCEEDED, UPDATING_GATING_FAILED,
  PUBLISH_GATING_REQUEST, PUBLISHING_GATING_SUCCEEDED, PUBLISHING_GATING_FAILED,
  RESTORE_GATING_REQUEST, RESTORING_GATING_SUCCEEDED, RESTORING_GATING_FAILED,
  CLONE_GATING_REQUEST, CLONING_GATING_SUCCEEDED, CLONING_GATING_FAILED,
  DELETE_GATING_REQUEST, DELETING_GATING_SUCCEEDED, DELETING_GATING_FAILED,
  RESET_GATING, UPDATE_GATING_SETTINGS, INVALIDATE_GATING_STATE,
  UPDATE_PROGRESSIVE_GATING_PROPERTY,
  UPDATE_GATING_PROGRESSIVE_PROPERTIES,
} from 'constants/actionTypes';

import { call, put, all, takeEvery, select, take } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';
import _ from 'lodash';

import { calculateOrderForWidgets } from 'components/Editor/helper/widget';
import { WidgetRegistry } from 'components/Editor/widgets/registry';
import { createEditorSession } from './editor';
import { LIVE_ELEMENT } from 'constants/widgetTypes';
import { registerEditorSessionReducer } from 'components/Editor/hooks/useEditorSession';
import { updateGatingConfigurations } from './storyboard';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const GATING_URL = `${apiUrl}/api/2.0/gating`;

/**
 * Fetch gating 
*/
export const fetchGating = createAction(FETCH_GATING_REQUEST, (id, preview) => {
  return {
    id: id,
    preview: preview
  };
})

export const fetchGatingSucceeded = createAction(FETCHING_GATING_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const fetchGatingFailed = createAction(FETCHING_GATING_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchGatingSaga(action) {
  const { id, preview } = action.payload;

  const url = buildUrl(GATING_URL, {
    path: `/${id}`
  });

  const fetchGatingAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchGatingAPI);
    if (response) {
      yield put(fetchGatingSucceeded(id, response));

      if (preview) {
        const sessionId = `editors_gating_${response.id}`;

        const widgets = _.get(response, 'draft.widgets', [])

        registerEditorSessionReducer(sessionId);
        yield put(createEditorSession(sessionId, {
          widgets: widgets
        }));

        //Live Widgets
        const liveElements = widgets.filter(item => item.type === LIVE_ELEMENT).map(widget => {
          const sessionId = `live_element_${widget.id}`;
          const initialState = {
            widgets: widget.children,
          };

          registerEditorSessionReducer(sessionId);

          return put(createEditorSession(sessionId, initialState));
        });

        yield all(liveElements);
      }
    }
  } catch (error) {
    yield put(fetchGatingFailed(id, error));
  }
}

/**
 * Reset gating
*/
export const resetGating = createAction(RESET_GATING, (page) => {
  return page
});

/**
 * Fetch gating For Editor
*/
export const fetchGatings = createAction(FETCH_GATINGS_REQUEST, (request, page, limit = 20) => {
  return {
    request: request,
    page: page,
    limit: limit
  };
})

const fetchGatingsSucceeded = createAction(FETCHING_GATINGS_SUCCEEDED, (response) => {
  return response;
})

const fetchGatingsFailed = createAction(FETCHING_GATINGS_FAILED, (error) => {
  return error;
})

function* fetchGatingsSaga(action) {
  const { request, page, limit } = action.payload;

  const url = buildUrl(GATING_URL, {
    path: `/search?page=${page}&limit=${limit}`
  });

  const fetchGatingsAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchGatingsAPI);

    if (response) {
      yield put(fetchGatingsSucceeded(response));
    }
  } catch (error) {
    yield put(fetchGatingsFailed(error));
  }
}

/**
 * Fetch gating For Selection
*/
export const fetchPublishedGatings = createAction(FETCH_PUBLISHED_GATINGS_REQUEST, (request, page, limit = 20) => {
  return {
    request: request,
    page: page,
    limit: limit
  };
})

const fetchPublishedGatingsSucceeded = createAction(FETCH_PUBLISHED_GATINGS_SUCCEEDED, (response) => {
  return response;
})

const fetchPublishedGatingsFailed = createAction(FETCH_PUBLISHED_GATINGS_FAILED, (error) => {
  return error;
})

function* fetchPublishedGatingsSaga(action) {
  const { request, page, limit } = action.payload;

  const url = buildUrl(GATING_URL, {
    path: `/search?page=${page}&limit=${limit}`
  });

  const fetchPublishedGatingsAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchPublishedGatingsAPI);

    if (response) {
      yield put(fetchPublishedGatingsSucceeded(response));
    }
  } catch (error) {
    yield put(fetchPublishedGatingsFailed(error));
  }
}

/**
 * Create gating
*/
export const createGating = createAction(CREATE_GATING_REQUEST, (request, callback) => {
  return {
    request: request,
    callback: callback
  };
})

const creatingGatingSucceeded = createAction(CREATING_GATING_SUCCEEDED, (response) => {
  return response;
})

const creatingGatingFailed = createAction(CREATING_GATING_FAILED, (error) => {
  return error;
})

function* createGatingSaga(action) {
  const { request, callback } = action.payload;

  const createGatingAPI = () => {
    return axios.post(GATING_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(createGatingAPI);

    if (response) {
      yield put(creatingGatingSucceeded(response));

      if (callback) {
        callback(response);
      }
    }
  } catch (error) {
    yield put(creatingGatingFailed(error));
  }
}

/**
 * Update gating
*/
export const updateGating = createAction(UPDATE_GATING_REQUEST, (id, editorSession) => {
  return {
    id: id,
    editorSession: editorSession
  };
})

const updatingGatingSucceeded = createAction(UPDATING_GATING_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  };
})

const updatingGatingFailed = createAction(UPDATING_GATING_FAILED, (error) => {
  return error;
})

function* updateGatingSaga(action) {
  const { id, editorSession } = action.payload;

  let url = buildUrl(GATING_URL, {
    path: `${id}`
  });

  const updateGatingAPI = (request) => {
    return axios({
      method: 'PUT',
      url: url,
      data: request
    }).then(response => response.data);
  }

  try {
    const snapshot = yield select(state => {
      var gating = _.get(state, `gatings.gating[${id}].item`);
      var name = _.get(gating, 'name', '');
      var themes = _.get(state, `${editorSession}.present.themes`);
      var brandTheme = _.get(state, `${editorSession}.present.brandTheme`, {}) || {};
      var breakpoint = _.get(state, `${editorSession}.present.breakpoint`);
      var request = { name, themes, brandTheme };
      const progressive = _.get(gating, 'progressive', false) || false;
      const progressiveGatingClusters = (_.get(gating, 'progressiveGatingClusters', []) || []).filter((cluster) => cluster.fields.length > 0).map((cluster) => {
        return {
          ...cluster,
          fields: cluster.fields.map((field) => typeof field === 'string' ? field : field.id)
        }
      });

      if (editorSession) {
        var widgets = _.get(state, `${editorSession}.present.widgets`);
        widgets = calculateOrderForWidgets(widgets, null);
        widgets = widgets.map((widget) => {
          let allFonts = [];
          if (widget.type === LIVE_ELEMENT) {
            let childrenWidgets = widget.children;
  
            childrenWidgets.forEach((childWidget) => {
              if (childWidget.fonts !== null && childWidget.fonts !== undefined) {
                childWidget.fonts.map((font) => allFonts.push(font));
              }
            });
            if (allFonts.length > 0) {
              widget.fonts = allFonts;
            }
          }
          return widget;
        });
        widgets = WidgetRegistry.processRequest(widgets);

        const desktopGuides = _.get(state, `${editorSession}.present.desktop.guides`);
        const mobileGuides = _.get(state, `${editorSession}.present.mobile.guides`);

        request = {
          ...request,
          widgets,
          desktopGuides: desktopGuides,
          mobileGuides: mobileGuides,
          progressive,
          progressiveGatingClusters
        }
      }

      return request;
    });
    const entityType = yield select((state) => _.get(state, `${editorSession}.present.entityType`));

    const response = yield call(updateGatingAPI, snapshot);

    if (response) {
      yield put(updatingGatingSucceeded(id, response));
    }

    /** Update gating items properties and gating configurations */
    if(entityType?.toUpperCase() === 'GATING' && response) { 
      yield put(updateGatingProgressiveProperties(response));
    }
  } catch (error) {
    yield put(updatingGatingFailed(id, error));
  }
}

/**
 * Publish gating
*/
export const publishGating = createAction(PUBLISH_GATING_REQUEST, (id, callback) => {
  return {
    id: id,
    callback: callback
  }
})

const publishGatingSucceeded = createAction(PUBLISHING_GATING_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const publishGatingFailed = createAction(PUBLISHING_GATING_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* publishGatingSaga(action) {
  const { id, callback } = action.payload;

  let url = buildUrl(GATING_URL, {
    path: `${id}/publish`
  });

  const publishGatingAPI = () => {
    return axios({
      method: 'POST',
      url: url,
    }).then(response => response.data);
  }

  try {
    const response = yield call(publishGatingAPI);
    yield put(publishGatingSucceeded(id, response));

    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(publishGatingFailed(id, error));
  }
}

/**
 * Restore gating
*/
export const restoreGating = createAction(RESTORE_GATING_REQUEST, (id, editorSession, callback) => {
  return {
    id: id,
    editorSession: editorSession,
    callback: callback
  }
})

const restoreGatingSucceeded = createAction(RESTORING_GATING_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const restoreGatingFailed = createAction(RESTORING_GATING_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* restoreGatingSaga(action) {
  const { id, editorSession, callback } = action.payload;

  let url = buildUrl(GATING_URL, {
    path: `${id}/restore`
  });

  const restoreGatingAPI = () => {
    return axios({
      method: 'POST',
      url: url,
    }).then(response => response.data);
  }

  try {
    const response = yield call(restoreGatingAPI);
    yield put(restoreGatingSucceeded(id, response));

    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(restoreGatingFailed(id, error));
  }
}

/**
 * Clone gating
*/
export const cloneGating = createAction(CLONE_GATING_REQUEST, (id, callback) => {
  return {
    id: id,
    callback: callback
  }
});

const cloningGatingSucceeded = createAction(CLONING_GATING_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const cloningGatingFailed = createAction(CLONING_GATING_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* cloneGatingSaga(action) {
  const { id, callback } = action.payload;

  let url = buildUrl(GATING_URL, {
    path: `${id}/clone`
  });

  const cloneGatingAPI = () => {
    return axios({
      method: 'POST',
      url: url,
    }).then(response => response.data);
  }

  try {
    const response = yield call(cloneGatingAPI);
    yield put(cloningGatingSucceeded(id, response));

    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(cloningGatingFailed(id, error));
  }
}

/**
 * Delete gating
*/
export const deleteGating = createAction(DELETE_GATING_REQUEST, (id, callback) => {
  return {
    id: id,
    callback: callback
  };
})

const deletingGatingSucceeded = createAction(DELETING_GATING_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  };
})

const deletingGatingFailed = createAction(DELETING_GATING_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  };
})

function* deleteGatingSaga(action) {
  const { id, callback } = action.payload;

  let url = buildUrl(GATING_URL, {
    path: id
  });

  const deleteGatingAPI = () => {
    return axios.delete(url).then(response => response.data);
  }

  try {
    const response = yield call(deleteGatingAPI);
    yield put(deletingGatingSucceeded(id, response));

    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(deletingGatingFailed(id, error));
  }
}

/** ------------ PROGRESSIVE GATING ------------ */

export const updateProgressiveGatingProperty = createAction(UPDATE_PROGRESSIVE_GATING_PROPERTY, (id, property) => {
  return {
    id: id,
    property: property
  }
});

/**
 * update gating settings
*/
export const updateGatingSettings = createAction(UPDATE_GATING_SETTINGS, (id, request) => {
  return {
    id: id,
    request: request
  }
})

/**
 * update gating items properties
 */

export const updateGatingProgressiveProperties = createAction(UPDATE_GATING_PROGRESSIVE_PROPERTIES, response => response)

/**
 * Invalidate Gating state
*/
export const invalidateGatingState = createAction(INVALIDATE_GATING_STATE, (id) => {
  return id;
})

export default function* gatingSaga() {
  yield takeEvery(FETCH_GATING_REQUEST, fetchGatingSaga);
  yield takeEvery(FETCH_GATINGS_REQUEST, fetchGatingsSaga);
  yield takeEvery(FETCH_PUBLISHED_GATINGS_REQUEST, fetchPublishedGatingsSaga);
  yield takeEvery(CREATE_GATING_REQUEST, createGatingSaga);
  yield takeEvery(UPDATE_GATING_REQUEST, updateGatingSaga);
  yield takeEvery(PUBLISH_GATING_REQUEST, publishGatingSaga);
  yield takeEvery(RESTORE_GATING_REQUEST, restoreGatingSaga);
  yield takeEvery(CLONE_GATING_REQUEST, cloneGatingSaga);
  yield takeEvery(DELETE_GATING_REQUEST, deleteGatingSaga);
}